import { useSelector } from 'react-redux';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

import { choiceTariff } from '../UploadBigFileDialog.helpers';
import { getTrialProduct128Gb1m } from '../UploadBigFileDialog.selectors';
import { Subscription } from '../UploadBigFileDialog.types';

export const useSubscription = (showProTariff: boolean): Subscription => {
    const trialSubscription = useSelector(getTrialProduct128Gb1m);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const { isFull: isOverQuota } = useSelector(UserSelectors.getCloudSpace);
    const { uploadLimit } = useSelector(UserSelectors.getUserData);
    const isTrialUser = Boolean(trialSubscription);
    const isUsualTariffUser = isPaidUser && uploadLimit <= SPACE_LIST.gb_32;
    const showTariffType = choiceTariff({ isTrialUser, isUsualTariffUser, isOverQuota, showProTariff });

    return {
        trialSubscription,
        uploadLimit,
        showTariffType,
        showProTariff,
    };
};
